const SURVEY_LIVE_STAMP = 20260717;

export function getChicagoDateStamp(date = new Date()) {
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Chicago",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const parts = formatter.formatToParts(date);
  const values = parts.reduce((acc, part) => {
    if (part.type !== "literal") {
      acc[part.type] = part.value;
    }
    return acc;
  }, {});

  return Number(`${values.year}${values.month}${values.day}`);
}

export function isSurveyLive(date = new Date()) {
  return getChicagoDateStamp(date) >= SURVEY_LIVE_STAMP;
}

export { SURVEY_LIVE_STAMP };
